import { FC } from "react";
import SmartSearchDateIntervalSelectAndActionsLayout from "../../../components/Layouts/smart-search-date-interval-select-and-actions-layout";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import {
  GetRevenueByGameParams,
  getRevenueByGame,
} from "../../../services/reports";
import { DateFormatEnum } from "../../../enums/dateFormatEnum";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";

const ReportRevenueByGame: FC = () => {
  return (
    <SmartSearchDateIntervalSelectAndActionsLayout
      searchBy={[
        SearchOptionEnum.DISTRIBUTOR,
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      
      validOnEmpty
      onRefresh={(
        output,
        params,
        startDateInterval,
        endDateInterval,
        select
      ) => {
        const getRevenueByGameParams: GetRevenueByGameParams = {
          output,
          beginDate: startDateInterval.format(DateFormatEnum.YEAR_MONTH_DAY),
          endDate: endDateInterval.format(DateFormatEnum.YEAR_MONTH_DAY), 
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getRevenueByGameParams[id] = params.id;
        }

        return getRevenueByGame(getRevenueByGameParams);
      }}
    />
  );
};

export default ReportRevenueByGame;
